import { useSelector } from 'react-redux';
import { IStore } from 'store/interface';
import { getInventoryIdentifiers } from '../../selector';

export const useInventoryIdentifiers = () => ({
  identifiers: useSelector<IStore, string[]>(getInventoryIdentifiers),
});
